import { PluginObject } from 'vue'

// v-dialog は ESC を .v-dialog__content の keydown でしか受けない。
// 背景クリックなどでフォーカスがダイアログの外（body）に出ると ESC が届かず閉じないため、
// 外で押された ESC を一番上のダイアログに渡し直す。

// JDialogContainer は document の keydown で自分で ESC を受けて閉じるので対象外にする
const SELF_HANDLED_DIALOG_CLASS = 'j-dialog-container'

const findTopDialogContent = (): HTMLElement | undefined => {
  const contents = Array.from(
    document.querySelectorAll<HTMLElement>('.v-dialog__content--active')
  )
  return contents.sort(
    (a, b) => Number(b.style.zIndex) - Number(a.style.zIndex)
  )[0]
}

const onKeydown = (event: KeyboardEvent) => {
  if (event.key !== 'Escape' || !event.isTrusted) return

  const top = findTopDialogContent()
  if (!top) return
  // フォーカスがダイアログ内にあれば、今までどおりダイアログ自身が処理する
  if (top.contains(event.target as Node)) return
  if (top.querySelector(`.${SELF_HANDLED_DIALOG_CLASS}`)) return

  // 元の ESC が document に届くと、下に重なった JDialogContainer が閉じてしまうので止める
  event.stopPropagation()
  // 各ダイアログの ESC 判定は keyCode を見るもの（onTyping）と key を見るもの（@keydown.esc）がある。
  // bubbles: false にして、document で ESC を受ける他のダイアログには届かないようにする
  top.dispatchEvent(
    new KeyboardEvent('keydown', {
      key: 'Escape',
      code: 'Escape',
      keyCode: 27,
      which: 27,
      bubbles: false,
      cancelable: true
    })
  )
}

const dialogEscKeyPlugin: PluginObject<void> = {
  install() {
    // JDialogContainer など document で ESC を受ける処理より先に動くよう、window の capture で受ける
    window.addEventListener('keydown', onKeydown, true)
  }
}

export default dialogEscKeyPlugin
